<template>
    <div>
        Every
        <span v-if="schedule.schedule_type === 'Daily'">Day</span>
        <span v-if="schedule.schedule_type === 'Weekly'">Week on {{ dayOfWeek[schedule.day_of_week] }}</span>
        <span v-if="schedule.schedule_type === 'Monthly'">Month on the {{ schedule.day_of_month }}{{ getMonthOrdinal(schedule.day_of_month) }}</span>
        <span v-if="schedule.schedule_type === 'Yearly'">Year on {{ (schedule.month_of_year + 1) + '/' + schedule.day_of_month }}</span>
        @ {{ getFormattedTime(schedule.schedule_time) }} <span class="text-muted">({{ schedule.timezone }})</span>

        <span class="badge badge-success" v-if="schedule.is_active == 1">Active</span>
        <span class="badge badge-warning" v-else>Inactive</span>

        <span class="badge badge-info" v-if="schedule.schedule_type === 'Daily' && schedule.exclude_weekends === 1">Excludes Weekends</span>

        <span class="badge badge-warning" v-if="schedule.save_to_report === 1"><i class=""></i> Save File Export to Report</span>
    </div>
</template>

<script>
    export default {
        props: {
            schedule: {
                type: Object,
                required: true,
            },
        },
        data() {
            return {
                dayOfWeek: [
                    'Sunday',
                    'Monday',
                    'Tuesday',
                    'Wednesday',
                    'Thursday',
                    'Friday',
                    'Saturday',
                ],

                monthOfYear: [
                    'January',
                    'February',
                    'March',
                    'April',
                    'May',
                    'June',
                    'July',
                    'August',
                    'September',
                    'October',
                    'November',
                    'December',
                ],
            }
        },

        watch: {

        },

        computed: {

        },

        methods: {
            getMonthOrdinal(day){
                //Check 'st'
                if(day === 1 || day === 21 || day === 31)
                {
                    return 'st';
                }

                if(day === 2 || day === 22)
                {
                    return 'nd';
                }

                if(day === 3 || day === 23)
                {
                    return 'rd';
                }

                //Default
                return 'th';
            },

            getFormattedTime(timestring){
                //Setup new moment
                var parts = timestring.split(":");

                //Check if first part is great than 12
                if(parseInt(parts[0]) >= 12)
                {
                    return parseInt(parts[0]) - 12 + ':' + parts[1] + ' PM';
                }

                //Default
                return parseInt(parts[0]) + ':' + parts[1] + ' AM';
            }
        },

        mounted() {

        }
    }
</script>
